module.exports = __webpack_public_path__ + "img/073680.ad0a2d9e.png";